import type { ReactNode, FC } from 'react';
import ListItemDiv from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemDiv';
import Flex from '@wix/da-ds/pkg/Flex';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import BatchActionForm from '../BatchActionForm';
import { BatchAction } from '../../../../types/store';

import s from './BatchActionItem.scss';

interface Props {
  action: BatchAction;
  label: ReactNode;
  isExpanded?: boolean;
  onExpand: (expand: boolean) => void;
  withCoreSymbol?: boolean;
}

const BatchActionItem: FC<Props> = ({
  action,
  label,
  isExpanded,
  onExpand,
  withCoreSymbol,
}) => {
  const arrowIcon = isExpanded ? (
    <ArrowUp size={IconSize.SMALL} />
  ) : (
    <ArrowDown size={IconSize.SMALL} />
  );
  return (
    <>
      <ListItemDiv
        className={s['root']}
        label={
          <Flex alignItems="center" className={s['label']}>
            {label}
            {withCoreSymbol ? (
              <CoreIcon
                size={IconSize.SMALL}
                disableDefaultColors
                className={s['core-icon']}
              />
            ) : undefined}
          </Flex>
        }
        suffix={arrowIcon}
        onClick={() => onExpand(!isExpanded)}
      />
      {isExpanded && (
        <div className={s['form']}>
          <BatchActionForm batchAction={action} />
        </div>
      )}
      <hr className={s['separator']} />
    </>
  );
};
BatchActionItem.displayName = 'BatchActionItem';

export default BatchActionItem;
